import React, { useEffect, useState } from 'react';
import { fetchOrganizationData } from '../services/api';
import OrganizationalInfo from '../profile/OrganizationalInfo.js';
import PersonalInfo from '../profile/PersonalInfo.js';
import { Box } from '@chakra-ui/react';

function AccountPage() {
  const [orgData, setOrgData] = useState({});

  const [isOrgDataEditing, setIsOrgDataEditing] = useState(false);

  useEffect(() => {
    const getData = async () => {
      const data = await fetchOrganizationData();
      console.log('[AccountPage] Data:', data);
      if (!data.error) {
        setOrgData(data);
      }
    };
    getData();
  }, []);

  const refreshData = async () => {
    const data = await fetchOrganizationData();
    console.log('[AccountPage] Data:', data);
    if (!data.error) {
      setOrgData(data);
    }
  }

  return (
    <Box style={{ paddingTop: '24px' }}>
      <Box marginX={"10%"}>
        {orgData.personal_info ? (
          <PersonalInfo
            name={orgData.personal_info.name}
            lastName={orgData.personal_info.last_name}
            role={orgData.personal_info.role}
            department={orgData.personal_info.department}
            photo={orgData.personal_info.profile_photo}
            refreshData={refreshData}
          />
        ) : (
          <p>Loading profile data...</p>
        )}
      </Box>
      <Box style={{ paddingTop: '48px' }} marginX={"10%"}>
        {orgData.organisation_info ? (
          <OrganizationalInfo
            name={orgData.organisation_info.name}
            websiteLink={orgData.organisation_info.website_link}
            otherLinks={orgData.otherLinks}
            canEditOrgData={orgData.config.can_edit_org_data}
            isEditing={isOrgDataEditing}
            setIsEditing={setIsOrgDataEditing}
            refreshData={refreshData}
          />
        ) : (
          <p>Loading organization data...</p>
        )}
      </Box>
    </Box>
  );
}

export default AccountPage;
